define.alias("shared/components/shared/collapsable-info-card", "settings/components/shared/collapsable-info-card");